import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['frame', 'body']
  static values = {
    autoOpen: Boolean,
    autoOpenUrl: String
  }

  connect() {
    this.frameLoadHandler = this.handleFrameLoad.bind(this)
    this.frameTarget.addEventListener('turbo:frame-load', this.frameLoadHandler)

    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.handleKeydown)

    // If already open (auto_open via server), just load the URL without animation
    if (this.autoOpenValue && this.hasAutoOpenUrlValue) {
      const isAlreadyOpen = this.element.classList.contains('components--ui--side-bar--open')
      if (isAlreadyOpen) {
        // Already open, just load content
        this.frameTarget.src = this.autoOpenUrlValue
      } else {
        // Not open yet, animate it open
        this.openWithUrl(this.autoOpenUrlValue)
      }
    }
  }

  disconnect() {
    if (this.frameTarget && this.frameLoadHandler) {
      this.frameTarget.removeEventListener('turbo:frame-load', this.frameLoadHandler)
    }

    document.removeEventListener('keydown', this.handleKeydown)
  }

  handleKeydown(event) {
    const isOpen = this.element.classList.contains('components--ui--side-bar--open')

    if (event.key === 'Escape' && isOpen) {
      this.close()
    }
  }

  openWithUrl(url) {
    this.frameTarget.src = url
    this.open()
  }

  handleFrameLoad(event) {
    // Content loaded successfully
  }

  toggle(url = null) {
    const isOpen = this.element.classList.contains('components--ui--side-bar--open')

    if (isOpen) {
      this.close()
    } else {
      if (url) {
        this.openWithUrl(url)
      } else {
        this.open()
      }
    }
  }

  open() {
    this.element.classList.add('components--ui--side-bar--open')
  }

  close() {
    // Hide content immediately to prevent squishing during animation
    if (this.hasBodyTarget) {
      this.bodyTarget.style.opacity = '0'
    }

    // Remove open class to trigger width animation
    this.element.classList.remove('components--ui--side-bar--open')

    // Emit custom event for other controllers to handle
    window.dispatchEvent(new CustomEvent('galette:sidebar:closed'))

    // Clear frame content after animation completes
    setTimeout(() => {
      this.frameTarget.removeAttribute('src')
      this.frameTarget.innerHTML = `
        <div class="text-center py-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      `
      // Reset opacity for next open
      if (this.hasBodyTarget) {
        this.bodyTarget.style.opacity = ''
      }
    }, 500)
  }
}
